import { useEffect, useState } from "react";
import { BASE_URL } from "../api/client";

// Public page content is deliberately optional: the existing design remains
// visible until an editor saves a page in CMS, and a temporary API outage
// never blanks the storefront.
export default function usePageContent(slug) {
  const [content, setContent] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetch(`${BASE_URL}/content/${slug}`)
      .then((response) => response.ok ? response.json() : null)
      .then((data) => { if (!cancelled && data?._id) setContent(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [slug]);
  return content;
}
